import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Chart as ChartJS,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import { callApiGet } from '../Helper/Network';
import { useTranslation } from '../locale/useTranslation';
// Enregistrer les composants de Chart.js
ChartJS.register(BarElement, ArcElement, CategoryScale, LinearScale, Tooltip, Legend);

const ConnectionStatsDashboard = () => {
      const { t, language, setLanguage, subscribe, tLang } = useTranslation();
  const [data, setData] = useState(null);
    const navigate = useNavigate();

    const loadData = async () => {
        const res = await callApiGet("/statistics", navigate);
        console.log(res);
        setData(res);
    }
  useEffect(() => {
    loadData();
  },[]);

  // Générateur de couleurs aléatoires harmonieuses
  const generateColors = (count) => {
    return Array.from({ length: count }, (_, i) =>
      `hsl(${(i * 360) / count}, 70%, 60%)`
    );
  };

  if (data != undefined) {

  // Histogramme : connexions par jour / OS
  const histogramData = {
    labels: data.connectionsByDay.map(d => d.date),
    datasets: [
      {
        label: 'Android',
        data: data.connectionsByDay.map(d => d.android),
        backgroundColor: '#3DDC84',
      },
      {
        label: 'iOS',
        data: data.connectionsByDay.map(d => d.ios),
        backgroundColor: '#007AFF',
      },
    ],
  };

  const histogramOptions = {
    responsive: true,
    plugins: {
      legend: { position: 'bottom' },
      title: { display: true, text: t('Connexions par jour et par OS') },
    },
  };

  // Camembert global OS
  const osPieData = {
    labels: ['Android: ' + data.summary.osDistribution.Android, 'iOS: ' + data.summary.osDistribution.iOS],
    datasets: [
      {
        data: [
          data.summary.osDistribution.Android,
          data.summary.osDistribution.iOS,
        ],
        backgroundColor: ['#3DDC84', '#007AFF'],
      },
    ],
  };

  // Camembert iOS versions
  const iosPieData = {
    labels: data.iosVersions.map(v => `iOS ${v.version}: ${v.count}`),
    datasets: [
      {
        data: data.iosVersions.map(v => v.count),
        backgroundColor: generateColors(data.iosVersions.length),
      },
    ],
  };

  // Camembert Android versions
  const androidPieData = {
    labels: data.androidVersions.map(v => `Android ${v.version}: ${v.count}`),
    datasets: [
      {
        data: data.androidVersions.map(v => v.count),
        backgroundColor: generateColors(data.androidVersions.length),
      },
    ],
  };

  // Style de mise en page
  const cardStyle = {
    background: '#fff',
    borderRadius: 12,
    padding: 20,
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  };

  // Rendu des graphiques
  return (
    <>
        <h1 className="hyappTitle">{t("Statistiques de connexion sur 30 jours glissants")}</h1>
<div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 20 }}>


      {/* 🔹 Ligne de 3 camemberts côte à côte */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: 20,
        }}
      >
        <div style={cardStyle}>
          <Pie
            data={osPieData}
            options={{ plugins: { title: { display: true, text: t('Répartition par OS') } } }}
          />
        </div>

        <div style={cardStyle}>
          <Pie
            data={iosPieData}
            options={{ plugins: { title: { display: true, text: t('Versions iOS') } } }}
          />
        </div>

        <div style={cardStyle}>
          <Pie
            data={androidPieData}
            options={{ plugins: { title: { display: true, text: t('Versions Android') } } }}
          />
        </div>        
      </div>
      {/* 🔹 Histogramme pleine largeur */}
      <div style={{ ...cardStyle }}>
        <Bar data={histogramData} options={histogramOptions} />
      </div>      
    </div>
    </>
  );
    }
    return;
};

export default ConnectionStatsDashboard;